import {Promise} from "bluebird";
import {apiRequest} from "./ApiRequest";
import {filterSupportedBalances} from "./Util";

const getClients = params => {
    const tasks = [];
    if (params?.clientType) {
        tasks.push(apiRequest("get", `/${params.clientType}Clients`, null, params));
    } else if (params?.type === "billing") {
        tasks.push(apiRequest("get", `/corporateClients`, null, params));
    } else {
        tasks.push(apiRequest("get", `/individualClients`, null, params));
        tasks.push(apiRequest("get", `/corporateClients`, null, params));
    }
    return Promise.all(tasks).then(responses => {
        const merged = responses.map(r => r.data).flat(1).sort((a, b) => b.createdAt - a.createdAt);
        merged.forEach(cl => {cl.balances = filterSupportedBalances(cl.balances);});
        return Promise.resolve(merged);
    });
};

const getClientDetails = client => {
    return apiRequest("get", `/${client.clientType}Clients/${client.id}`).then(response => {
        const profile = response.data;
        profile.balances = filterSupportedBalances(profile.balances);
        return Promise.resolve(profile);
    });
};

const editClient = (id, data) => {
    return apiRequest("put", `/${data.clientType}Clients/` + id, data).then(response => {
        if (data.addedFiles?.length) {
            const formData = new FormData();
            data.addedFiles.forEach(f => {
                formData.append("upload", f);
            });
            apiRequest("post", `/${data.clientType}Clients/${response.data.id}/files`, formData);
        }
        if (data.deletedFiles) {
            Promise.map(data.deletedFiles, df => apiRequest("delete", df.src));
        }
        return Promise.resolve(response.data);
    });
};

const createClient = data => {
    return apiRequest("post", `/${data.clientType}Clients`, data).then(response => {
        if (data.addedFiles?.length) {
            const formData = new FormData();
            data.addedFiles.forEach(f => {
                formData.append("upload", f);
            });
            return apiRequest("post", `/${data.clientType}Clients/${response.data.id}/files`, formData).then(() => Promise.resolve(response.data));
        }
        return Promise.resolve(response.data);
    });
};

const deleteClient = client => {
    return apiRequest("delete", `/${client.clientType}Clients/${client.id}`).then(response => {
        return Promise.resolve(response.data);
    });
};

const uploadClients = data => {
    return apiRequest("post", "/clients", data).then(response => {
        return Promise.resolve(response.data);
    });
};

const testCredentials = data => {
    return apiRequest("post", "/walletClients/testCredentials", data).then(response => {
        return Promise.resolve(response.data);
    });
};

export {getClients, getClientDetails, editClient, createClient, deleteClient, uploadClients, testCredentials};
